export default function isStringOnlyWithLatinLettersAndNumbers(value) {
    const hasOnlyLettersAndNumbers = !!value.match(/^[a-z0-9]+$/i);

    if (value != "" && !hasOnlyLettersAndNumbers) {
        return false; 
    }
    return true;
}